<template>
  <Loader v-if="loading && editMode"></Loader>
  <div v-else>
    <Breadcrumb :items="items" />
    <noData v-if="noData" />
    <!-- ==== Start Form ==== -->
    <form @submit.prevent="validateCreateForm">
      <div class="container">
        <div class="row justify-content-between">
          <div class="col-lg-6 py-0">
            <div class="input_wrapper top_label">
              <input
                @keypress="isArabic"
                type="text"
                class="form-control"
                @input="helper_checkIfInputIsEmpty"
                v-model.trim="data.ar.name"
              />
              <label for="name_input" class="form-label">
                {{ $t("forms.labels.title_ar") }}
              </label>
            </div>
          </div>

          <div class="col-lg-6 py-0">
            <div class="input_wrapper top_label">
              <input
                @keypress="isEnglish"
                type="text"
                class="form-control"
                @input="helper_checkIfInputIsEmpty"
                v-model.trim="data.en.name"
              />
              <label for="name_input" class="form-label">
                {{ $t("forms.labels.title_en") }}
              </label>
            </div>
          </div>

          <div class="col-lg-6 py-0">
            <div class="input_wrapper top_label">
              <input
                type="text"
                class="form-control"
                @input="helper_checkIfInputIsEmpty"
                v-model.trim="data.icon"
              />
              <label for="name_input" class="form-label">
                {{ $t("forms.labels.icon") }}
              </label>
            </div>
          </div>

          <div class="col-lg-6 py-0">
            <div class="input_wrapper top_label">
              <input
                @keypress="isEnglish"
                type="text"
                class="form-control"
                @input="helper_checkIfInputIsEmpty"
                v-model.trim="data.key"
              />
              <label for="name_input" class="form-label"> Key </label>
            </div>
          </div>

          <!-- <div class="col-12 py-0">
              <div class="input_wrapper top_label">
                <label for="textarea_1" class="form-label">
                  {{ $t("forms.labels.priority") }}
                </label>
                <input
                  type="number"
                  class="form-control"
                  rows="5"
                  v-model="data.priority"
                />
              </div>
            </div> -->
        </div>
      </div>

      <div class="buttons_wrapper">
        <button class="button_style_1" :disabled="btnIsLoading">
          {{ $t("forms.submit") }}
          <span class="btn_loader" v-if="btnIsLoading"></span>
        </button>
      </div>
    </form>
    <!-- ==== End Form ==== -->
  </div>
</template>

<script>
export default {
  name: "Create",
  props: ["id"],
  data() {
    return {
      noData: false,
      loading: false,
      btnIsLoading: false,
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.permission-labels.title"),
          disabled: false,
          href: "/permission-labels/show-all",
        },
        {
          text: this.$t("breadcrumb.permission-labels.add"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Loading

      // ========== create_data
      data: {
        ar: {
          name: null,
        },
        en: {
          name: null,
        },
        icon: null,
        key: null,
      },
    };
  },
  computed: {
    editMode() {
      return !!this.id;
    },
  },

  methods: {
    resetForm() {
      this.data.ar.name = null;
      this.data.en.name = null;
      this.data.icon = null;
      this.data.key = null;
    },
    // Validate Data

    //validate Form
    validateCreateForm() {
      if (!this.data.ar.name) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.name_ar"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.en.name) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.name_en"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else {
        this.submitData();
      }
    },
    // Submit Data
    submitData() {
      this.btnIsLoading = true;
      const frmData = new FormData();
      frmData.append("ar[name]", this.data.ar.name);
      frmData.append("en[name]", this.data.en.name);
      if (this.data.icon) {
        frmData.append("icon", this.data.icon);
      }
      if (this.data.key) {
        frmData.append("key", this.data.key);
      }

      if (this.id) {
        frmData.append("_method", "PUT");
      }
      let url = "";

      if (this.id) {
        url = `permission_label/${this.id}`;
      } else {
        url = "permission_label";
      }

      let message = this.id ? this.$t("editSuccess") : this.$t("addSuccess");

      this.$axios
        .post(url, frmData)
        .then(() => {
          this.$iziToast.success({
            title: this.$t("success"),
            message: message,
          });

          this.$router.push("/permission-labels/show-all");

          this.btnIsLoading = false;
        })
        .catch((err) => {
          this.btnIsLoading = false;
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message ?? err.response.data.messages,
            position: "bottomRight",
          });
        });
    },
    getEditData() {
      this.noData = false;
      if (this.editMode) {
        this.loading = true;
        this.$axios({
          method: "GET",
          url: `permission_label/${this.id}`,
        })
          .then((res) => {
            this.loading = false;
            this.data = {
              ar: res.data.data.ar,
              en: res.data.data.en,
              key: res.data.data.key,
              icon: res.data.data.icon,
              // is_active: res.data.data.is_active,
            };
          })
          .catch((err) => {
            this.$iziToast.error({
              title: this.$t("error"),
              message:
                err.response?.data.message ?? err.response?.data.messages,
            });
            this.noData = true;

            this.loading = false;
          });
      }
    },
  },

  created() {
    this.control = this.$permission.setControls(this.$route.path);
    if (this.id) {
      this.getEditData();
    }
  },
};
</script>
